<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import {useStore} from "vuex";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import router from "@/router";

export default {
  name: "SearchBy",
  components: {LoadingPage},
  setup(){

    let store = useStore()

    let profile = FreeWorld.PinkMan(store.state.profile , 'de')
    let filter_homepage = store.state.filter.HomePage === null ? null : FreeWorld.PinkMan(store.state.filter.HomePage , 'de')

    console.log(filter_homepage)
    console.log(profile)

    let loading = ref(false)
    let word = ref(useRoute().params.word)

    let ads = ref([])
    
    function search() {

      let data = {
        word:word.value,
      }

      data.city_id = filter_homepage !== null ? filter_homepage.city_id : profile.city_id

      loading.value = true
      FreeWorld.Heisenberg(data , 'search_adver' , true).then((res)=>{

        loading.value = false
        ads.value = res.data

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , search)
      })
    }
    search()

    function seen_ads(item) {
      store.commit('set_advertising' , item)
      router.push({name:'DetailsAdvertising'})
    }
    
    
    return{
      loading,
      search,
      ads,
      seen_ads,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">

    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <router-link :to="{name:'HomePage'}">
      <img class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      </router-link>
      <p class="text-white font-bold font-4">نتایج جستجو</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div v-if="ads.length === 0"
           class="animate__animated animate__fadeIn w-100 h-75 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>

      <div v-else v-for="item in ads" :key="item.id" @click="seen_ads(item)"
           class="animate__animated animate__fadeIn bg-white shadow-custom p-2 d-flex justify-content-between rounded-4 mb-3">
        <div class="d-flex flex-column justify-content-around w-60">
          <div class="overflow-hidden">
            <p class="text-color font-bold font-4" :class="item.title.length >= 30 ? 'txtoverflow':''">{{ item.title }}</p>
          </div>

          <p class="font-5">{{ item.price }} تومان</p>

          <p class="font-6">{{ item.time }}</p>

          <div class="hr-dash"></div>

          <p class="font-5">{{ item.state }} - {{ item.city }}</p>
        </div>

        <div class="img-ads rounded-4 animated-background">
          <img class="img-ads rounded-4 img-cover" :src="item.pic1" alt="">
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.img-ads {
  width: 10rem;
  height: 10rem;
}

.hr-dash {
  width: 100%;
  height: .1rem;
  border-bottom: .1rem dashed #0335BE;
}

select {
  -webkit-appearance: none; /* برای مرورگرهای وب‌کیت */
  -moz-appearance: none; /* برای مرورگرهای فایرفاکس */
  appearance: none;
}
</style>